import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { LanguageProvider } from "@/context/LanguageContext";
import { BlogProvider } from "@/context/BlogContext";
import { SEOHead } from "@/components/SEOHead";
import { Navbar } from "@/components/Navbar";
import { HeroSection } from "@/components/HeroSection";
import { FeaturesSection } from "@/components/FeaturesSection";
import { CRMSection } from "@/components/CRMSection";
import { FurnitureSection } from "@/components/FurnitureSection";
import { EcosystemSection } from "@/components/EcosystemSection";
import { HowItWorksSection } from "@/components/HowItWorksSection";
import { CapabilitiesSection } from "@/components/CapabilitiesSection";
import { MultiDeviceSection } from "@/components/MultiDeviceSection";
import { IntegrationsMarquee } from "@/components/IntegrationsMarquee";
import { PricingSection } from "@/components/PricingSection";
import { FAQSection } from "@/components/FAQSection";
import { ContactSection } from "@/components/ContactSection";
import { Footer } from "@/components/Footer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";
import { PageHero } from "@/components/PageHero";
import { LegalPage } from "@/components/LegalPage";
import { BlogListPage } from "@/pages/blog/BlogListPage";
import { BlogDetailPage } from "@/pages/blog/BlogDetailPage";
import { BlogCategoryPage } from "@/pages/blog/BlogCategoryPage";
import { BlogTagPage } from "@/pages/blog/BlogTagPage";

/* ─── Full Landing (Ana Sayfa) ─── */
function HomePage() {
  return (
    <>
      <SEOHead page="home" />
      <HeroSection />
      <HowItWorksSection />
      <FeaturesSection />
      <CapabilitiesSection />
      <EcosystemSection />
      <MultiDeviceSection />
      <CRMSection />
      <FurnitureSection />
      <IntegrationsMarquee />
      <PricingSection />
      <FAQSection />
      <ContactSection />
    </>
  );
}

/* ─── Özellikler Sayfası ─── */
function FeaturesPage() {
  return (
    <>
      <SEOHead page="features" />
      <PageHero page="features" />
      <HowItWorksSection />
      <FeaturesSection />
      <CapabilitiesSection />
      <EcosystemSection />
      <MultiDeviceSection />
      <CRMSection />
      <FurnitureSection />
      <IntegrationsMarquee />
    </>
  );
}

/* ─── Fiyatlandırma Sayfası ─── */
function PricingPage() {
  return (
    <>
      <SEOHead page="pricing" />
      <PageHero page="pricing" />
      <PricingSection />
    </>
  );
}

/* ─── SSS Sayfası ─── */
function FAQPage() {
  return (
    <>
      <SEOHead page="faq" />
      <PageHero page="faq" />
      <FAQSection />
    </>
  );
}

/* ─── İletişim Sayfası ─── */
function ContactPage() {
  return (
    <>
      <SEOHead page="contact" />
      <PageHero page="contact" />
      <ContactSection />
    </>
  );
}

/* ─── Gizlilik Politikası ─── */
function PrivacyPage() {
  return (
    <>
      <SEOHead page="privacy" />
      <LegalPage docKey="privacy" />
    </>
  );
}

/* ─── Kullanım Koşulları ─── */
function TermsPage() {
  return (
    <>
      <SEOHead page="terms" />
      <LegalPage docKey="terms" />
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <LanguageProvider>
          <BlogProvider>
            <div className="App min-h-screen bg-white">
              <Navbar />
              <main>
                <Routes>
                  {/* ─── Türkçe (default) ─── */}
                  <Route path="/" element={<HomePage />} />
                  <Route path="/ozellikler" element={<FeaturesPage />} />
                  <Route path="/fiyatlandirma" element={<PricingPage />} />
                  <Route path="/sss" element={<FAQPage />} />
                  <Route path="/iletisim" element={<ContactPage />} />
                  <Route path="/gizlilik-politikasi" element={<PrivacyPage />} />
                  <Route path="/kullanim-kosullari" element={<TermsPage />} />
                  {/* Blog TR */}
                  <Route path="/blog" element={<BlogListPage />} />
                  <Route path="/blog/kategori/:slug" element={<BlogCategoryPage />} />
                  <Route path="/blog/etiket/:tag" element={<BlogTagPage />} />
                  <Route path="/blog/:slug" element={<BlogDetailPage />} />

                  {/* ─── İngilizce ─── */}
                  <Route path="/en" element={<HomePage />} />
                  <Route path="/features" element={<FeaturesPage />} />
                  <Route path="/pricing" element={<PricingPage />} />
                  <Route path="/faq" element={<FAQPage />} />
                  <Route path="/contact" element={<ContactPage />} />
                  <Route path="/privacy-policy" element={<PrivacyPage />} />
                  <Route path="/terms-of-service" element={<TermsPage />} />
                  {/* Blog EN */}
                  <Route path="/en/blog" element={<BlogListPage />} />
                  <Route path="/en/blog/kategori/:slug" element={<BlogCategoryPage />} />
                  <Route path="/en/blog/etiket/:tag" element={<BlogTagPage />} />
                  <Route path="/en/blog/:slug" element={<BlogDetailPage />} />

                  {/* ─── Arapça ─── */}
                  <Route path="/ar" element={<HomePage />} />
                  <Route path="/ar/ozellikler" element={<FeaturesPage />} />
                  <Route path="/ar/fiyatlandirma" element={<PricingPage />} />
                  <Route path="/ar/sss" element={<FAQPage />} />
                  <Route path="/ar/iletisim" element={<ContactPage />} />
                  <Route path="/ar/gizlilik-politikasi" element={<PrivacyPage />} />
                  <Route path="/ar/kullanim-kosullari" element={<TermsPage />} />
                  {/* Blog AR */}
                  <Route path="/ar/blog" element={<BlogListPage />} />
                  <Route path="/ar/blog/kategori/:slug" element={<BlogCategoryPage />} />
                  <Route path="/ar/blog/etiket/:tag" element={<BlogTagPage />} />
                  <Route path="/ar/blog/:slug" element={<BlogDetailPage />} />

                  {/* ─── Fallback → Ana Sayfa ─── */}
                  <Route path="*" element={<HomePage />} />
                </Routes>
              </main>
              <Footer />
              <WhatsAppFloat />
            </div>
          </BlogProvider>
        </LanguageProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
